/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HealthCamp from './health-camp';
import HealthCampDetail from './health-camp-detail';
import HealthCampUpdate from './health-camp-update';
import HealthCampDeleteDialog from './health-camp-delete-dialog';

const HealthCampRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HealthCamp />} />
    <Route path="new" element={<HealthCampUpdate />} />
    <Route path=":id">
      <Route index element={<HealthCampDetail />} />
      <Route path="edit" element={<HealthCampUpdate />} />
      <Route path="delete" element={<HealthCampDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HealthCampRoutes;
